/**
 * useSessionExpired Hook
 * Manages global 401 Unauthorized error handling with modal
 * Use in App.tsx to listen for 401 errors globally
 */

import { useEffect, useState, useRef } from 'react';
import { useAuthContext } from '../components/Auth/AuthProvider';

// Global event bus for 401 errors (since we need to handle them across components)
const sessionExpiredEmitter = new EventTarget();
const SESSION_EXPIRED_EVENT = 'SESSION_EXPIRED';

export function triggerSessionExpiredModal() {
  const event = new Event(SESSION_EXPIRED_EVENT);
  sessionExpiredEmitter.dispatchEvent(event);
}

export function useSessionExpired() {
  const [isSessionExpired, setIsSessionExpired] = useState(false);
  const { user } = useAuthContext();
  const hasShownModal = useRef(false);

  useEffect(() => {
    const handleSessionExpired = () => {
      // Only show modal if user is actually logged in
      if (user && !hasShownModal.current) {
        hasShownModal.current = true;
        setIsSessionExpired(true);
      }
    };

    sessionExpiredEmitter.addEventListener(SESSION_EXPIRED_EVENT, handleSessionExpired);

    return () => {
      sessionExpiredEmitter.removeEventListener(SESSION_EXPIRED_EVENT, handleSessionExpired);
    };
  }, [user]);

  const closeModal = () => {
    hasShownModal.current = false;
    setIsSessionExpired(false);
  };

  return {
    isSessionExpired,
    closeModal,
  };
}
